import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import store from './redux/store';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Products from './pages/Products';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Career from './pages/Career';
import JobDetails from './pages/JobDetails';
import JobApplication from './pages/JobApplication';
import { Blog } from './pages/Blog';
import ProductDetails from './pages/ProductDetails';
import ServiceDetail from './pages/ServiceDetail';
import ScrollToTop from './components/ScrollToTop';

// Admin imports
import Login from './pages/admin/Login';
import Signup from './pages/admin/Signup';
import Dashboard from './pages/admin/Dashboard';
import BlogManagement from './pages/admin/BlogManagement';
import JobManagement from './pages/admin/JobManagement';
import UserManagement from './pages/admin/UserManagement';
import ApplicationManagement from './pages/admin/ApplicationManagement';
import AdminAuthGuard from './components/AdminAuthGuard';
import AdminLayout from './layouts/AdminLayout';

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router>
        <ScrollToTop />
        <Routes>
          {/* Public routes with MainLayout */}
          <Route path="/*" element={
            <MainLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetails />} />
                <Route path="/services/:serviceId/:subItemId?" element={<ServiceDetail />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/career" element={<Career />} />
                <Route path="/job-details/:id" element={<JobDetails />} />
                <Route path="/job-application/:id" element={<JobApplication />} />
                <Route path="/blog/*" element={<Blog />} />
              </Routes>
            </MainLayout>
          } />
          
          {/* Login and Signup routes without MainLayout */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          
          {/* Admin routes with AdminLayout */}
          <Route path="/admin/dashboard" element={
            <AdminAuthGuard>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/blogs" element={
            <AdminAuthGuard>
              <AdminLayout>
                <BlogManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/jobs" element={
            <AdminAuthGuard>
              <AdminLayout>
                <JobManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/users" element={
            <AdminAuthGuard>
              <AdminLayout>
                <UserManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/applications" element={
            <AdminAuthGuard>
              <AdminLayout>
                <ApplicationManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/jobs/new" element={
            <AdminAuthGuard>
              <AdminLayout>
                <JobManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
          <Route path="/admin/blogs/new" element={
            <AdminAuthGuard>
              <AdminLayout>
                <BlogManagement />
              </AdminLayout>
            </AdminAuthGuard>
          } />
        </Routes>
        </Router>
      </Provider>
    </HelmetProvider>
  );
}

export default App; 